import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseApiTemplateService, Core2Config, ApiVisa, BasicApiResponseModel } from "../../shared";
import { GenericDocFileExportContainerModel } from "../../../../../../models/aggregates/generic_doc/generic-doc-file-export.model";
import { GenericDocSearchCriteriaDtoModel } from "../../../data-transfer-objects";

@Injectable({ providedIn: "root" })
export class GenericDocFileExportService extends BaseApiTemplateService<GenericDocFileExportContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "gen-doc-exports/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "gen-doc-exports/backoffice-ep";
    this.httpClient = http;
  }

  generateGenericDocFile(doctype: string, dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + doctype + '/generate-csv';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl,dtoObject,this.getHttpHeader(visa));
  }

  downloadReport(guid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/' + guid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }
} 
